// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7v-0";
export var startPickingButton = "_7v-1";